import React from "react";
import { Link } from "react-router-dom";

export default function LinkTo({ to, target = "_self",children }) {
  return <Link to={to} target={target}>{children}</Link>;
}
